import { render, staticRenderFns } from "./CompaniesView.vue?vue&type=template&id=5ef3ba1e&"
import script from "./CompaniesView.vue?vue&type=script&lang=ts&"
export * from "./CompaniesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports